import { CheckoutFormElemetDataType } from '@/components/sections/builder/elements/body/checkout-form/type';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import { ElementProps } from '@/components/sections/builder/types';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSetting({ element }: ElementProps) {
  const content = element.data as CheckoutFormElemetDataType;
  const builder = useBuilderStore((state) => state, shallow);

  return (
    <div>
      <div className='mb-2 flex flex-col gap-3'>
        <span className='text-xs font-bold'>Layout Position</span>
        <InputTab
          grid={2}
          defaultValue={content.layoutPosition || 'left'}
          options={[
            { label: 'Left', value: 'left' },
            { label: 'Right', value: 'right' },
          ]}
          onChange={(v) => builder.setElementData(element.id, { layoutPosition: v })}
        />
      </div>
      <span className='mb-2 flex text-xs font-bold'>Label continue shopping</span>
      <Input
        name='labelContinueShopping'
        defaultValue={content.labelContinueShopping || 'Continue shopping'}
        value={content.labelContinueShopping}
        maxLength={30}
        onChange={(e) => {
          builder.setElementData(element.id, {
            labelContinueShopping: e.target.value,
          });
        }}
        className='mb-2'
      />
      <span className='mb-2 flex text-xs font-bold'>Label button paynow</span>
      <Input
        name='labelButtonPayNow'
        defaultValue={content.labelButtonPayNow || 'Pay Now'}
        value={content.labelButtonPayNow}
        maxLength={30}
        onChange={(e) => {
          builder.setElementData(element.id, {
            labelButtonPayNow: e.target.value,
          });
        }}
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme Checkout Form</div>
      <SchemeSetting
        value={content.colorSchemeForm || DEFAULT_THEME_COLOR_SCHEME}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorSchemeForm: theme,
          });
        }}
      />

      <div className='mb-2 mt-4 font-bold'>Color scheme Checkout Item</div>
      <SchemeSetting
        value={content.colorSchemeItem || DEFAULT_THEME_COLOR_SCHEME}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorSchemeItem: theme,
          });
        }}
      />
      <InputSlider
        label='Radius checkout item'
        value={content.radiusCheckoutItem || 0}
        min={0}
        max={100}
        onChange={(val) =>
          builder.setElementData(element.id, {
            radiusCheckoutItem: val,
          })
        }
      />

      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='stickyContent'
          aria-label='Select'
          className='mx-2'
          checked={content.stickyContent}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              stickyContent: !!checked,
            });
          }}
        />
        <Label htmlFor='stickyContent' className='text-xs font-bold '>
          Sticky content item on desktop
        </Label>
      </div>
      {content.stickyContent && (
        <InputSlider
          label='Top content sticky'
          value={content.topContent || 0}
          min={0}
          max={100}
          onChange={(val) =>
            builder.setElementData(element.id, {
              topContent: val,
            })
          }
        />
      )}
    </div>
  );
}
